import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { getDefaultActions } from './factories';

const state = {
    actions: getDefaultActions(),
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
